import * as moment from "moment-timezone";
import * as React from "react";

import { IDrop } from "src/core/drops/api/drops.api";
import useCutoffByDate from "src/core/orders/hooks/validation/useCutoffByDate";
import { IProduct } from "src/core/products/api/products.api";
import { Text } from "src/library/components/Text";

import { formatDate } from "../api";

/**
   * Returns an array of dates with warning messages if needed
   */
export const useWarningDeliveryDates = (inputDrop?: IDrop): typeof isWarning => {
  const cutoffByDate = useCutoffByDate(inputDrop);

  const isWarning = React.useCallback((date: Date, orderVariantId: number, product?: IProduct) => {
    const deliveryDate = moment.utc(date);
    const cutoff = cutoffByDate(deliveryDate.toDate(), "shortest", orderVariantId, product?.leadTimeGroup);

    if (moment.utc().isSame(cutoff, "day")) {
      const split = formatDate(cutoff, "HH:mm");

      return {
        isWarning: true,
        component: (
          <Text className="warning">
            {`Place your order before ${split}`}
          </Text>
        )
      };
    }

    return { isWarning: false };
  }, [ cutoffByDate ]);

  return isWarning;
};
